import Echo from 'laravel-echo';

window.io = require('socket.io-client');
window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: window.Laravel.websocketUrl,
});

function redirectQueuedRequest() {
    if(QueuedRequest.isDone) {
        // Petite securité en cas de multiples appels
        return;
    }
    QueuedRequest.isDone = true;
    if (QueuedRequest.method == 'GET') {
        document.location.href = QueuedRequest.formatedUri;
    }
    else {

        var form = document.createElement('form');
        form.method = 'POST';
        form.action = QueuedRequest.uri;

        if (QueuedRequest.method != 'POST') {

            var method = document.createElement('input');
            method.type = 'hidden';
            method.name = '_method';
            method.value = QueuedRequest.method;

            form.appendChild(method);
        }

        var uuid = document.createElement('input');
        uuid.type = 'hidden';
        uuid.name = 'uuid';
        uuid.value = QueuedRequest.uuid;

        form.appendChild(uuid);

        document.body.appendChild(form);
        form.submit();
    }
};

function sendQueuedAjaxRequest() {

    var request = new XMLHttpRequest();

    var data = JSON.stringify({
        '_token': Laravel.csrfToken,
        'user_id': userId,
        'uuid': QueuedRequest.uuid
    });

    request.open('POST', route('queue_request').toString());
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(data);
};

if (QueuedRequest.uri) {
    if (location.hash) {
        QueuedRequest.formatedUri = QueuedRequest.formatedUri + location.hash;
        history.replaceState({}, '', QueuedRequest.uri);
    }

    Helpers.removeUrlQueryParameters(['position', 'uri', 'method']);

    var userId = Number(Laravel.user);

    window.Echo.connector.socket.on('connect', function() {

        sendQueuedAjaxRequest();
    });

    if (userId) {

        window.Echo.private('App.User.' + userId + '.' + QueuedRequest.uuid)
            .listen('RequestUnqueud', () => {

                redirectQueuedRequest();
            });
    }
    else {

        window.Echo.channel('App.Client.' + QueuedRequest.uuid)
            .listen('RequestUnqueud', () => {

                redirectQueuedRequest();
            });
    }
} else {
    history.back();
}

function getQueueInfo() {
    $.ajax({
        url: route('queue_info',QueuedRequest.uuid).toString(),
        method: "GET",
        contentType: "application/json",
        success: function(result){
            $("#js-chargement").css('display','none');
            $("#js-file-attente").css('display','block');
            $("#js-position").html(result.position);
            if(result.position == 0){
                // Si position a 0, on force la redirections
                QueuedRequest.isDone = false;
                redirectQueuedRequest();
            }
            $("#js-time-estimated").html(result.estimated+" min");
        }
    });
}
// On actualise une fois dans 10 secondes, puis toutes les 2 minutes
setTimeout(getQueueInfo,10000);
setInterval(getQueueInfo,120000);
